import React, { useState } from "react";
import { Formik, FieldArray, Field } from "formik";
import { motion, AnimatePresence } from "framer-motion";
import close from "../../assets/close.svg";
import { interesse } from "./kat";
import { useData } from "../../util/dataProvider";

export default function Page3({
    setPage,
    page,
    values,
    errors,
    validateForm,
    touched,
}) {
    const { assetUrl } = useData();

    function validate(value) {
        let error;
        if (!value || value.length == 0) {
            error = "*Pflichtfeld";
        } else {
            error = null;
        }
        return error;
    }
    function isEmpty(obj) {
        return Object.keys(obj).length === 0;
    }
    console.log(values);
    return (
        <AnimatePresence>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className='page2-form'>
                <label htmlFor='company-focus' className='label'>
                    Welche Interessen haben Sie?
                </label>
                <Field
                    id='interested-'
                    name='interested'
                    type='text'
                    validate={validate}
                    style={{ height: 0, padding: 0, border: "none" }}
                />
                <FieldArray
                    name='interested'
                    render={(arrayHelpers) => (
                        <div>
                            <div className='item-box-container'>
                                {values.interested &&
                                    values.interested.map((item, index) => {
                                        return (
                                            <div
                                                className='item'
                                                key={"selectitem2-" + index}
                                                onClick={() =>
                                                    arrayHelpers.remove(index)
                                                }>
                                                {item}{" "}
                                                <img src={assetUrl + close} />
                                            </div>
                                        );
                                    })}
                            </div>
                            {errors.interested && touched.interested && (
                                <div className='errors'>
                                    {errors.interested}
                                </div>
                            )}
                            <div className='item-box-item-list'>
                                {interesse.map((item, idx) => (
                                    <div
                                        key={`interesse-${idx}`}
                                        className='item'
                                        onClick={() =>
                                            arrayHelpers.push(item.value)
                                        }>
                                        {item.label}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}></FieldArray>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}>
                    <button
                        onClick={() => setPage(page - 1)}
                        className='button-red'>
                        Zurück
                    </button>
                    <button
                        onClick={() =>
                            validateForm().then((errors) => {
                                if (isEmpty(errors)) {
                                    setPage(page + 1);
                                } else {
                                    console.log("errors: ", errors);
                                }
                            })
                        }
                        className='button-red'>
                        Weiter
                    </button>
                </div>
            </motion.div>
        </AnimatePresence>
    );
}
